import script from "./SearchArticle.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchArticle.vue?vue&type=script&setup=true&lang=js"

import "./SearchArticle.vue?vue&type=style&index=0&id=4eb7570a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eb7570a"]])

export default __exports__